import React, { useCallback } from 'react';

import { IconsEnum } from '../../../../../assets/icons/types';
import { IsDisabled } from '../../../../../types';
import {
  FetchLifestylesFilterFields,
  LifestylesAiSearchOnClipGlobalSearch
} from '../../../../lifestyles/lifestylesTypes';

import { LifestylesAiSearchClipGlobalModalButton } from '../../../../lifestyles/components/buttons/LifestylesAiSearchClipGlobalModalButton';

import { TextFilter } from '../../../../../helpers/filters/TextFilter';

import { aiSearchKeys, lifestylesKeys } from '../../../../../locales/keys';

interface ThreeDStockLifestylesSearchFieldProps {
  withSimilarImageFilter?: boolean;
  value?: string;
  onSearch?: (value?: string) => void;
  onSearchSimilarImage?: (imageId?: string, imageUrl?: string) => void;
  disabled?: IsDisabled;
}

function ThreeDStockLifestylesSearchField({
  withSimilarImageFilter,
  value = '',
  onSearch,
  onSearchSimilarImage,
  disabled
}: ThreeDStockLifestylesSearchFieldProps) {
  const handleSearch = useCallback<
    (
      changedFilters: { [nameTags: string]: string },
      removeFilters: string[]
    ) => void
  >(
    ({ nameTags }) => {
      onSearch(nameTags);
    },
    [onSearch]
  );

  const handleSearchSimilarImage =
    useCallback<LifestylesAiSearchOnClipGlobalSearch>(
      (data) => {
        onSearchSimilarImage(
          data.fileAttachment?.id,
          data.fileAttachment?.file
        );
      },
      [onSearchSimilarImage]
    );

  return (
    <div className="relative grow flex-1 py-2">
      <TextFilter
        changeOnEnter
        dataGa="three-d-stock-lifestyles-text-filter-input"
        disabled={disabled}
        i18nPlaceholder={lifestylesKeys.search}
        icon={IconsEnum.SEARCH_OUTLINE}
        iconClassName="stroke-2 h-6 w-6 shrink-0 pointer-events-none"
        iconWrapperClassName="absolute left-4 top-3"
        inputClassName="pl-12 pr-24 flex items-center gap-2 h-full w-full border rounded-full shadow-inner bg-gray-100 border-gray-500 dark:bg-gray-950 dark:border-gray-500 hover:border-gray-900 dark:hover:border-blue-200 focus-within:hover:border-blue-300 focus-within:ring-primary transition-colors duration-150 ease-out"
        className="h-full w-full relative"
        name={FetchLifestylesFilterFields.NAME_TAGS}
        onChange={handleSearch}
        value={value}
        type="text"
      />

      {withSimilarImageFilter && (
        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 flex border-l border-gray-300 dark:border-gray-700 pl-2">
          <LifestylesAiSearchClipGlobalModalButton
            className="py-1.5 pl-1.5 pr-1.5 sm:pr-3 sm:space-x-1 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-5 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0 transition-colors duration-150 ease-out"
            dataGa="three-d-stock-lifestyles-clip-global-search-filter-button"
            i18nText={aiSearchKeys.imageSearch}
            i18nTextClassName="sr-only sm:not-sr-only normal-case"
            i18nTitle={aiSearchKeys.imageSearch}
            icon={IconsEnum.PHOTO_AI_SOLID}
            iconClassName="h-5 w-5"
            onSubmit={handleSearchSimilarImage}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default ThreeDStockLifestylesSearchField;
